export default __webpack_public_path__ + "abd5230b275b204ef771faf0d757cc89.png";